import { motion } from "framer-motion";
import WaitlistDialog from "./WaitlistDialog";

const EmailSignup = () => {
  return (
    <WaitlistDialog
      trigger={
        <motion.button
          type="button"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="px-10 py-4 bg-gradient-gold text-primary-foreground font-body text-sm font-semibold uppercase tracking-[0.25em] transition-all duration-300 hover:shadow-gold"
        >
          Join The Academy
        </motion.button>
      }
    />
  );
};

export default EmailSignup;
